import ClienteController from "@/shared/controllers/cliente/clienteController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import TransportadoraController from "@/shared/controllers/transportadora/transportadoraController";
import EVENTS from "@/shared/events/events";

const name = 'InfoFrete'
export default {
  name,

  components: { },

  props: { },

  mounted () {
    this.getInformacoesPedidoId()
    
    this.atualizaEmpresaRepresentante()

    this.ImagemEmpresa()

    this.UpdatePedidoSituacao()

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.atualizaEmpresaRepresentante()
    })
  },

  updated () {

  },

  data () {
    return {
      enderecoIdClienteSelecionado: '',
      EnderecoId: null,
      PedidoLoteFreteArray: [],
      EnderecoNovoPedidoArray: [],
      UpdateEnderecoClienteArray: [],
      cartaArray: [],
      CidadeId: null,
      ClienteId: null,
      clienteSelecionadoId: null,
      pedidoId: null,
      enderecoClienteId: null,
      nomeEndereco: '',
      bairro: '',
      cep: '',
      complemento: '',
      siglaEstado: '',
      nomeCidade: '',
      indicadorDeTipoFreteText: '',
      indicadorDeTipoFrete: '',
      desativa: false,
      naosim: null,
      desativaTransporte: false,
      botaoSimENao: false,
      popup:false,
      clienteByCidadeArray: [],
      codigoSelecionado: undefined,
      razaoSocialSelecionada: undefined,
      PedidoId: null,
      transportadoraSelecionada: null,
      TransportadoraArray: [],
      empresaId: null,
      imagemEmpresa: '',
      clienteIdEntrega: null,
      ClientesArray: []
    }
  },


  methods: {

    UpdatePedidoSituacao(){
    
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/UpdatePedidoSituacao/${this.$route.params.id}`,
      })
        .then((response) => {
  
         console.log(response)
        })
        .catch();
    },

  ImagemEmpresa(){
    this.axios({
      method: 'get',
      url: process.env.VUE_APP_WEB_API + `Pedido/GetNomeEmpresaByPedidoId/${this.$route.params.id}`,
    })
      .then((response) => {

        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
      .catch();
  },
    getInformacoesPedidoId () {
      this.$isLoading(true)
      OrcamentoController.getOrcamentoLoteFreteByPedido(this.$route.params.id).requisicao
        .then((Response) => {
          this.RetornaInformacao(Response.data.data)
          this.validaçãoTipoFrete(Response.data.data)
          this.PedidoLoteFreteArray = Response.data.data
          if(this.PedidoLoteFreteArray.codigoclienteEntrega != null && this.PedidoLoteFreteArray.codigoclienteEntrega != ""){
            this.buscarClientesRetorno(this.PedidoLoteFreteArray.codigoclienteEntrega + ' ') //gambiarra pq se n ele n achava pra preencher 
          this.botaoSimENao = 1
          }
          //this.populaCodigoECliente() 
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },

    buscarClientesRetorno(event) {
        ClienteController.GetClientesDropdownPedidoEntrega(event,this.$store.state.representanteSelecionadoId, this.PedidoLoteFreteArray.empresaId, this.$route.params.id).requisicao
        .then(res => {
          this.ClientesArray = res.data.data;
          let clienteselecionado = this.ClientesArray.find((Element) => Element.codigoExterno.trim() == this.PedidoLoteFreteArray.codigoclienteEntrega)
          this.enderecoIdClienteSelecionado = clienteselecionado.codigoExterno

        })
        .catch(() => {
        });
    },
    TrazerInfosTransportadora(){
      if(this.indicadorDeTipoFrete != 2 && this.transportadoraSelecionada != null){
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `Orcamento/TrazerInfosTransportadora/${this.transportadoraSelecionada}`,
        })
          .then((response) => {
            this.PopulaInfoTransportadora(response.data.data)

            
          })
          .catch();
      }  
    },

    PopulaInfoTransportadora(data){
      if(data.transportadoraId != null) {
        this.transportadoraSelecionada = data.transportadoraId
        let datainput = [{
          id: data.transportadoraId,
          nomeTransportadora: data.nomeTransportadora,
          labelTransportadora: data.nomeTransportadora
        }]
        this.TransportadoraArray = datainput
      }
      this.CidadeId = data.cidadeId
      this.EnderecoId = data.enderecoId
      this.ClienteId = data.clienteId
      this.nomeEndereco = data.nomeEndereco
      this.bairro = data.bairro
      this.cep = data.cep
      this.complemento = data.complemento
      this.siglaEstado = data.siglaEstado
      this.nomeCidade = data.nomeCidade
      
    },

    clienteEndereco(){
      this.axios({
        method: 'get',
        url:process.env.VUE_APP_WEB_API +`Pedido/GetEnderecoPadraoCliente/${this.ClienteId}`,
    })
        .then((response) => {
          this.EnderecoId = response.data.data.enderecoId
          this.nomeEndereco = response.data.data.nome
          this.bairro = response.data.data.bairro
          this.cep = response.data.data.cep
          this.complemento = response.data.data.complemento
        })
        .catch(() => {
        });
  },
  
    

    RetornaInformacao(data){
      if(data.transportadoraId != null) {
        this.transportadoraSelecionada = data.transportadoraId
        let datainput = [{
          id: data.transportadoraId,
          nomeTransportadora: data.nomeTransportadora,
          labelTransportadora: data.nomeTransportadora
        }]
        this.TransportadoraArray = datainput
      }
      this.CidadeId = data.cidadeId
      this.EnderecoId = data.enderecoId
      this.ClienteId = data.clienteId
      this.nomeEndereco = data.nomeEndereco
      this.bairro = data.bairro
      this.cep = data.cep
      this.complemento = data.complemento
      this.siglaEstado = data.siglaEstado
      this.nomeCidade = data.nomeCidade
      this.indicadorDeTipoFreteText = data.indicadorDeTipoFreteText
    },

    RetornaEnderecoCliente(data){
      this.CidadeId = data.cidadeId
      this.EnderecoId = data.enderecoId
      this.clienteId = data.clienteId
      this.nomeEndereco = data.nome
      this.bairro = data.bairro
      this.cep = data.cep
      this.complemento = data.complemento
    },

    GerarNovoEndereco (){
      let EnderecoNovoPedidoArray = {
          ClienteId: this.clienteId,
          PedidoId: this.$route.params.id,
          nome: this.nomeEndereco,
          cep: this.cep,
          bairro: this.bairro,
          complemento: this.complemento,
      }
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Endereco/EnderecoNovoPedido',
        data: EnderecoNovoPedidoArray
    })
        .then((response) => {
            this.GetResultForm(response)
        })
        .catch(() => {
        });
    },

    UpdateEnderecoCliente (){
      //   this.axios({
      //     method: 'post',
      //     url:process.env.VUE_APP_WEB_API +`Pedido/NovoEnderecoPedido/${this.$route.params.id}/${this.EnderecoId}`,
      // })
      //     .then((response) => {
      //         this.GetResultForm(response)
      //     })
      //     .catch(() => {
      //     });

      if(this.botaoSimENao ==0)
      this.enderecoIdClienteSelecionado = ''


      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Pedido/UpdateCodigoClienteEntregaPedido`,
        data:{
          CodigoClienteEntrega: this.enderecoIdClienteSelecionado,
          PedidoId: this.$route.params.id
       }
      })
        .then((response) => {

        //  this.OrcamentoId = response.data.data
        //  this.tipoFluxoOrcamento = response.data.data
        console.log(response)
        
        }
         )


      //dando update em pedido pra salvar o codigoclietneentrega
    },

    buscarClientes(event) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ClienteController.GetClientesDropdownPedidoEntrega(event,this.$store.state.representanteSelecionadoId, this.PedidoLoteFreteArray.empresaId, this.$route.params.id).requisicao
        .then(res => {
          this.ClientesArray = res.data.data;
        })
        .catch(() => {
        });
      }, 1000);
    },

    ehFormularioValido(){
      let warnArray = []
      if(this.enderecoIdClienteSelecionado == '' && this.indicadorDeTipoFrete === 0 ){
        warnArray.push('Necessário Adicionar um Endereço de Entrega!')
      }
      
      if(this.indicadorDeTipoFrete === 3 /* 'CIF - Redespacho'*/ && this.transportadoraSelecionada == null){
        warnArray.push('Necessário Adicionar uma Transportadora!')  
      }

      warnArray.forEach(warn => {
        this.$toast.add({ severity: 'warn', summary: 'AVISO', detail: warn, life: 7000 })
      
      })

      return warnArray.length === 0 
    },

    Continuar() {
      /*eslint-disable*/
      switch(this.indicadorDeTipoFrete){
        case 0:
          if(this.enderecoIdClienteSelecionado == ''){//validar qui se o frete é cif - redespacho
            this.$toast.add({ severity: 'warn', summary: 'AVISO', detail: 'Necessário Adicionar um Endereço de Entrega!', life: 7000 })
            return
          }
          else{
            this.UpdateEnderecoCliente()
          }

        break
        case 1:
          // this.GerarNovoEndereco()
        break
        case 2:
        break
        case 3:
        break
      }

      if(this.ehFormularioValido()){
        this.SalvaTransportadoraId()
      }

    },

    SalvaTransportadoraId() {
      this.$refs.botaoContinuar.isBusy()

      this.axios({
        method: "post",
        url: process.env.VUE_APP_WEB_API + `Pedido/PostTransportadoraId/${this.$route.params.id}/${this.transportadoraSelecionada}`,
      })
        .then(() => {  
          this.UpdateEnderecoCliente()
        
        })
        .catch(() => {
        }).finally( () => {
          this.$refs.botaoContinuar.isBusy()
          this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/produto-em-carregamento-pedido`)

        }
          


        );
    },
    Voltar() {
      this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/info-cliente-pedido`)
    },

    abrePopup () {
      this.popup=true
    },

    fechaPopup(){
      this.popup = false
    },

     DisplayNone() {
      const list = document.getElementById("EsconderEnderecoDiferenteFaturamento").classList;
      list.add("escoder");
     },

     populaCodigoECliente() {
      // this.axios({
      //   method: "get",
      //   url: process.env.VUE_APP_WEB_API + `Pedido/GetClientePedidoByCidadeId/${this.CidadeId}`,
      // })
      //   .then((response) => {
      //   this.clienteByCidadeArray = response.data.data;
      //   this.codigoSelecionado = response.data.data.codigo;
      //   this.razaoSocialSelecionada = response.data.data.razaoSocial;
      //   this.enderecoClienteId = response.data.data.enderecoId;
      //   this.clienteSelecionadoId = response.data.data.id;
      //   })
      //   .catch(() => {
      //   });



    },

    selecionaCodigo(idSelecionado){
      this.clienteByCidadeArray.forEach(obj=>{
        if(obj.enderecoId === idSelecionado){
          this.codigoSelecionado = obj.codigo
          this.RetornaEnderecoCliente(obj)
        }
      })
    },

    edicaoCliente() {
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/verificacliente',
        data:
        {
          Id: this.clienteId
        }
      })
        .then((response) => {
          this.$store.state.cliente = response.data.data

          let arrayAjustado = response.data.data.clienteAgrupadores.map(e => {
            return this.converteClienteAgrupador(e)
          })

          this.$store.state.cliente.clienteAgrupadores = arrayAjustado

          this.$store.commit('salvando');

          this.situacaoVindaDoBanco= response.data.data.clienteSituacao

          if(response.data.data != null){
            this.popupjaexiste=true;
          }

          this.situacaoVindaDoBanco
          if (this.situacaoVindaDoBanco === 0){
            this.$router.push(`/ficha-cadastro/${this.clienteId}`)
        } else
          {
          this.$router.push(`/cliente-em-desenvolvimento/${this.clienteId}`)
        }
        })
        .catch();
    },


    validaçãoTipoFrete(data){
      this.indicadorDeTipoFrete = data.indicadorDeTipoFrete

      switch(this.indicadorDeTipoFrete){
        case 0:
          this.desativa = true
          this.desativaTransporte = true
          this.botaoSimENao = 1
        break
        case 1:
          this.desativa = true
          this.desativaTransporte = true
          this.DisplayNone()
        break
        case 2:
          this.desativa = true
          this.desativaTransporte = true
          this.DisplayNone()
        break
        case 3:
          this.desativa = true
          this.desativaTransporte = false
          this.DisplayNone()
        break
      }
    },

    buscarTransportadoras(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let pedidoId = this.$route.params.id;
        TransportadoraController.getTransportadoras(event, this.empresaId, pedidoId).requisicao
          .then((res => {
            this.TransportadoraArray = res.data.data
          }))
      }, 2000);
    },

    atualizaEmpresaRepresentante(){
      this.empresaId = this.$store.state.empresaSelecionadaId;
      // this.objFiltro.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },
  },

  computed: {

   },

};
